<div class="ion-padding">
  <ion-button class="big-text-btn" (click)="navigate()" [color]="b.layout == 10 ? 'primary' : 'success'" [innerHTML]="b.title"></ion-button>
</div>